module.exports = __webpack_public_path__ + "img/icon-add-outline.c9d7b603.svg";